import React, { Suspense } from "react";
import Loading from "widgets/loading";

const DocViewer = React.lazy(() => import("@cyntler/react-doc-viewer"));

interface LazyDocViewerProps {
  documents: any[];
  pluginRenderers?: any[];
  config?: any;
  className?: string;
}

export const LazyDocViewer: React.FC<LazyDocViewerProps> = (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <DocViewer {...props} />
    </Suspense>
  );
};

//  ------------------------------------------------------------

const PDFRenderer = React.lazy(() => import("widgets/pdf-renderer"));

export const LazyPDFRenderer = (props: any) => {
  return (
    <Suspense fallback={<Loading />}>
      <PDFRenderer {...props} />
    </Suspense>
  );
};

LazyPDFRenderer.fileTypes = ["pdf", "application/pdf"];
LazyPDFRenderer.weight = 0;

//  ------------------------------------------------------------

const ReactDatePicker = React.lazy(() => import("react-datepicker"));

export const LazyReactDatePicker: React.FC<any> = (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <ReactDatePicker {...props} />
    </Suspense>
  );
};

const Stories = React.lazy(() => import("react-insta-stories"));

export const LazyStories: React.FC<any> = (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <Stories {...props} />
    </Suspense>
  );
};

//  ------------------------------------------------------------

export const useLazyDeviceDetect = () => {
  const [deviceDetect, setDeviceDetect] = React.useState<any>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    import("react-device-detect")
      .then((module) => {
        setDeviceDetect(module);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Failed to load react-device-detect:", error);
        setIsLoading(false);
      });
  }, []);

  return { deviceDetect, isLoading };
};

// Convenience hook for isMobile
export const useLazyIsMobile = () => {
  const { deviceDetect, isLoading } = useLazyDeviceDetect();
  return { isMobile: deviceDetect?.isMobile || false, isLoading };
};

//  ------------------------------------------------------------

const RangeSliderInput = React.lazy(() => import("react-range-slider-input"));

export const LazyRangeSliderInput: React.FC<any> = (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <RangeSliderInput {...props} />
    </Suspense>
  );
};

//  ------------------------------------------------------------

export const useLazyInternationalPhone = () => {
  const [internationalPhone, setInternationalPhone] = React.useState<any>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    import("react-international-phone")
      .then((module) => {
        setInternationalPhone(module);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Failed to load react-international-phone:", error);
        setIsLoading(false);
      });
  }, []);

  return { internationalPhone, isLoading };
};
